"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Map, Building2, Leaf, Lightbulb, Sprout, Monitor, Scissors, ArrowRight } from "lucide-react";
const projects = [{
  id: 1,
  title: "Hudson Master Suite",
  category: "Bathroom Remodeling",
  description: "A complete master bathroom transformation featuring a custom walk-in tile shower and premium dual vanities.",
  image: "https://amazing-satyr.10web.cloud/wp-content/uploads/2026/03/IMG_8866-scaled.jpg?v=d7gppq34eks",
  colSpan: "md:col-span-8",
  icon: Map
}, {
  id: 2,
  title: "River Falls Culinary",
  category: "Kitchen Remodeling",
  description: "Traditional kitchen upgrade with custom cabinetry, quartz countertops, and an optimized functional layout.",
  image: "https://amazing-satyr.10web.cloud/wp-content/uploads/2026/03/post_completed-project-e3182588.webp?v=6ouojughtnk",
  colSpan: "md:col-span-4",
  icon: Building2
}, {
  id: 3,
  title: "Prescott Living Space",
  category: "Basement Remodeling",
  description: "Finished lower level featuring a family media room, guest bathroom, and high-quality storage solutions.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/project_prescott_basement.png",
  colSpan: "md:col-span-4",
  icon: Leaf
}, {
  id: 4,
  title: "Custom Tile Detail",
  category: "Bathroom Detail",
  description: "Precision tile work and custom niches that demonstrate our 20+ years of dedicated craftsmanship.",
  image: "https://amazing-satyr.10web.cloud/wp-content/uploads/2026/03/IMG_6948-scaled.jpg?v=bn7r5swyvor",
  colSpan: "md:col-span-4",
  icon: Lightbulb
}, {
  id: 5,
  title: "Ellsworth Open Concept",
  category: "Kitchen Design",
  description: "Modernized kitchen space designed for family gatherings with premium finishes and warm lighting.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/project_ellsworth_kitchen.png",
  colSpan: "md:col-span-4",
  icon: Sprout
}, {
  id: 6,
  title: "Luxury Spa Retreat",
  category: "Bathroom Remodeling",
  description: "High-end bathroom renovation focusing on luxury finishes, accessibility, and a relaxing atmosphere.",
  image: "https://amazing-satyr.10web.cloud/wp-content/uploads/2026/03/IMG_8719-scaled.jpg?v=j1e6iut92pn",
  colSpan: "md:col-span-6",
  icon: Monitor
}, {
  id: 7,
  title: "Classic Home Addition",
  category: "Precision Remodeling",
  description: "Expert structural updates and interior finishing that blend seamlessly with the original home architecture.",
  image: "https://amazing-satyr.10web.cloud/wp-content/uploads/2026/03/IMG_4357-scaled.jpg?v=ax8gb2eim0w",
  colSpan: "md:col-span-6",
  icon: Scissors
}];
export default function PremiumPortfolioShowcase() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.05
  });
  return <section data-section-id="146925" id="projectgallery" className="py-[120px] bg-background text-foreground overflow-hidden" ref={ref}>
      <div className="container mx-auto px-4 md:px-6">
        <div className={`flex flex-col items-center text-center mb-16 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <span className="text-primary font-sans font-semibold tracking-wider uppercase text-sm mb-4 block">
            Our Recent Work
          </span>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-6 max-w-3xl">
            Craftsmanship That Lasts a Lifetime
          </h2>
          <p className="font-sans text-muted-foreground text-lg max-w-2xl">
            Explore our gallery of completed bathroom, kitchen, and basement remodels. With over 20 years of experience, Finely Done brings quality and integrity to every Hudson area home.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 mb-16">
          {projects.map((project, i) => {
          const Icon = project.icon;
          return <div key={project.id} data-index={i} className={`relative group overflow-hidden rounded-sm h-[400px] md:h-[480px] ${project.colSpan} transition-all duration-1000 ease-out delay-[${i * 100}ms] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                <img src={project.image} alt={project.title} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-[1.02] saturate-100" />
                
                {}
                <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                
                {}
                <div className="absolute bottom-6 left-6 right-6 translate-y-8 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500 ease-out bg-background/90 backdrop-blur-md border border-border/50 rounded-sm p-6 shadow-md">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="p-2 bg-primary/10 rounded-sm">
                      <Icon className="w-5 h-5 text-primary stroke-[1.5]" />
                    </div>
                    <span className="text-xs font-semibold text-primary tracking-wider uppercase font-sans">
                      {project.category}
                    </span>
                  </div>
                  <h3 className="text-2xl font-bold text-foreground mb-2 font-serif">
                    {project.title}
                  </h3>
                  <p className="text-muted-foreground text-sm font-sans line-clamp-2">
                    {project.description}
                  </p>
                </div>
              </div>;
        })}
        </div>

        <div className={`flex justify-center transition-all duration-1000 ease-out delay-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <Button asChild size="lg" className="rounded-sm px-8 h-14 text-base font-sans bg-primary text-primary-foreground hover:bg-primary/90">
            
          </Button>
        </div>
      </div>
    </section>;
}